<template>
  <div id="defaultId1">
    <div id="cc18ed" class="udb507 u22483 pb20">
      <div id="g2ede8" class="operations-content">
        <div>
          <div class="operations-box" style="margin-top: 10px">
            <div
              id="ge6845"
              label=""
              :isShowLabel="false"
              style="margin-right: 10px; width: 45%"
            >
              <div style="width: 100%; height: 100%">
                <div class="operations-box-left">
                  <div style="width: 100%; height: 100%">
                    <h2 id="gf7b16" class="operations-head-content">
                      <div class="operations-head">
                        {{ $t("CompetitiveAnalysis.MarketPosition") }}
                        <span class="other_lab"
                          >{{ $t("FinancialHighlight.Country") }} :
                          {{ getCountry(this.$route.query.companyCountry) }}
                        </span>
                      </div>
                      <span class="ViewMore contclass">
                        <div
                          :class="
                            iconactive2 == 'table'
                              ? 'svgbg svgclass'
                              : 'svgclass'
                          "
                        >
                          <svg
                            t="1718592308727"
                            v-if="iconactive2 == 'table'"
                            class="icon icon_size"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="8137"
                          >
                            <path
                              d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                              fill="#1290C9"
                              p-id="8138"
                            ></path>
                          </svg>

                          <svg
                            t="1718592110652"
                            v-else
                            @click="iconactive2 = 'table'"
                            class="icon icon_size"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7626"
                          >
                            <path
                              d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                              fill="#5C5C66"
                              p-id="7627"
                            ></path>
                          </svg>
                        </div>
                        <div
                          :class="
                            iconactive2 == 'computer'
                              ? 'svgbg svgclass'
                              : 'svgclass'
                          "
                        >
                          <svg
                            t="1718592168330"
                            v-if="iconactive2 == 'computer'"
                            class="icon icon_size"
                            viewBox="0 0 1214 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7861"
                          >
                            <path
                              d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                              fill="#1290C9"
                              p-id="7862"
                            ></path>
                            <path
                              d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                              fill="#1290C9"
                              p-id="7863"
                            ></path>
                          </svg>

                          <svg
                            t="1718592454748"
                            @click="iconactive2 = 'computer'"
                            v-else
                            class="icon icon_size"
                            viewBox="0 0 1214 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="8412"
                          >
                            <path
                              d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                              fill="#000000"
                              p-id="8413"
                            ></path>
                            <path
                              d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                              fill="#000000"
                              p-id="8414"
                            ></path>
                          </svg>
                        </div>
                      </span>
                    </h2>
                    <div
                      class="flex_center_between_box"
                      style="justify-content: start"
                    >
                      <el-select
                        popper-class="common_select"
                        v-model="PerformanceComparisvalueone"
                        filterable
                        ref="upSelect3"
                        v-click-outside="clickOutSide3"
                        placeholder="Select a Year"
                        @change="PerformanceComparisvalueonechange"
                        style="width: 240px; font-size: 20px"
                      >
                        <el-option
                          v-for="(item, index) in reationsoptions"
                          :key="index"
                          :label="item.reportYear"
                          :value="item.reportYear"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div v-show="iconactive2 == 'table'" class="Attribute-left">
                      <el-table
                        :data="AttributeData"
                        style="width: 100%"
                        row-class-name="highlight-row"
                        :cell-class-name="cellClassName"
                      >
                        <el-table-column
                          label=""
                          prop="attributeName"
                          width="130"
                          align="left"
                        >
                          <template slot-scope="scope">
                            <span
                              class="table-content"
                              style="font-family: 'Arial Bold'"
                              >{{ scope.row.attributeName }}</span
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('CompetitiveAnalysis.Revenus')"
                          align="right"
                          prop="turnover"
                          width="130"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span class="table-content">{{
                              formatNumber(scope.row.turnover)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('CompetitiveAnalysis.NetEarnings')"
                          align="right"
                          prop="NetPprofit"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span class="table-content">{{
                              formatNumber(scope.row.netProfit)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('CompetitiveAnalysis.NetAssets')"
                          align="right"
                          prop="NetAssets"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span class="table-content">{{
                              formatNumber(scope.row.netAssets)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('CompetitiveAnalysis.TotalAssets')"
                          align="right"
                          prop="TotalAssets"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span class="table-content">{{
                              formatNumber(scope.row.totalAssets)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          :label="$t('CompetitiveAnalysis.Employees')"
                          align="right"
                          prop="Employee"
                          width="140"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span class="table-content">{{
                              formatNumber(scope.row.employee)
                            }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div
                      v-show="iconactive2 == 'computer'"
                      ref="Attributechart"
                      style="height: 760px"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="ge6845"
              class="uc1096"
              label=""
              :isShowLabel="false"
              style="flex: 1"
            >
              <div
                class="operations-box-right operations-box-left"
                style="width: 100%"
              >
                <div style="width: 100%">
                  <h2 id="gf7b16" class="operations-head-content">
                    <div class="operations-head">
                      {{ $t("CompetitiveAnalysis.PerformanceComparison") }}
                      <span class="other_lab"
                        >{{ $t("FinancialHighlight.Country") }} :
                        {{ getCountry(this.$route.query.companyCountry) }}</span
                      >
                    </div>
                    <span class="ViewMore contclass">
                      <div
                        :class="
                          iconactive == 'table' ? 'svgbg svgclass' : 'svgclass'
                        "
                      >
                        <svg
                          t="1718592308727"
                          v-if="iconactive == 'table'"
                          class="icon icon_size"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8137"
                        >
                          <path
                            d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                            fill="#1290C9"
                            p-id="8138"
                          ></path>
                        </svg>

                        <svg
                          t="1718592110652"
                          v-else
                          @click="iconactive = 'table'"
                          class="icon icon_size"
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7626"
                        >
                          <path
                            d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
                            fill="#5C5C66"
                            p-id="7627"
                          ></path>
                        </svg>
                      </div>
                      <div
                        :class="
                          iconactive == 'computer'
                            ? 'svgbg svgclass'
                            : 'svgclass'
                        "
                      >
                        <svg
                          t="1718592168330"
                          v-if="iconactive == 'computer'"
                          class="icon icon_size"
                          viewBox="0 0 1214 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="7861"
                        >
                          <path
                            d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                            fill="#1290C9"
                            p-id="7862"
                          ></path>
                          <path
                            d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                            fill="#1290C9"
                            p-id="7863"
                          ></path>
                        </svg>

                        <svg
                          t="1718592454748"
                          @click="zhuhuangcehartsi()"
                          v-else
                          class="icon icon_size"
                          viewBox="0 0 1214 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="8412"
                        >
                          <path
                            d="M94.734629 819.2c-52.0192 0-94.354286-40.872229-94.354286-91.077486V341.284571c0-13.312 11.190857-24.107886 24.9856-24.107885 13.780114 0 22.908343 10.795886 22.908343 24.107885v386.823315c0 23.639771 21.986743 44.675657 46.460343 44.675657h1018.953142c24.488229 0 47.030857-21.035886 47.030858-44.675657V93.037714c0-23.6544-22.528-43.695543-47.030858-43.695543H94.734629C70.261029 49.3568 48.274286 69.397943 48.274286 93.037714v107.373715c0 13.297371-9.128229 24.093257-22.908343 24.093257-13.794743 0-25.000229-10.795886-25.000229-24.107886V93.037714C0.365714 42.832457 42.715429 1.989486 94.734629 1.989486h1018.953142c52.0192 0 94.339657 40.842971 94.339658 91.077485v635.070172c0 50.205257-42.320457 91.077486-94.339658 91.077486H94.734629z"
                            fill="#000000"
                            p-id="8413"
                          ></path>
                          <path
                            d="M704.2048 965.485714H855.771429c12.112457 0 21.694171 11.264 21.694171 23.376457 0 12.112457-9.581714 23.6544-21.694171 23.6544h-482.742858c-12.112457 0-22.191543-11.541943-22.191542-23.6544 0-12.127086 10.079086-23.376457 22.191542-23.376457h151.581258V819.2H570.514286v146.285714h87.771428V819.2h45.919086v146.285714zM177.678629 620.163657h44.426971V461.531429h-44.426971zM296.1408 620.163657h44.412343V389.412571h-44.412343zM429.407086 620.163657h44.412343V317.293714h-44.412343zM236.909714 187.4944c0 15.915886-13.268114 28.847543-29.608228 28.847543-16.384 0-29.622857-12.931657-29.622857-28.847543 0-15.945143 13.253486-28.847543 29.622857-28.847543 16.340114 0 29.608229 12.9024 29.608228 28.847543M325.749029 187.4944c0 15.915886-13.268114 28.847543-29.608229 28.847543s-29.608229-12.931657-29.608229-28.847543c0-15.945143 13.268114-28.847543 29.608229-28.847543s29.608229 12.9024 29.608229 28.847543M714.591086 420.322743h148.728685l112.347429-93.432686c-26.814171-30.939429-68.183771-52.077714-112.347429-52.077714-79.491657 0-146.666057 66.530743-148.728685 145.5104zM820.662857 568.188343l21.869714-113.2544h-126.098285c16.310857 53.642971 51.053714 91.399314 104.228571 113.2544z m174.474972-210.549029l-91.428572 77.297372 91.428572 54.535314C1004.251429 470.381714 1009.371429 446.800457 1009.371429 424.228571c0-23.2448-4.593371-47.074743-14.2336-66.589257zM877.714286 462.760229l-20.289829 110.270171c1.594514 0.043886 3.189029 0.073143 4.783543 0.073143 44.909714 0 87.815314-20.904229 114.644114-52.736L877.714286 462.760229zM863.085714 614.4c-105.033143 0-190.171429-85.138286-190.171428-190.171429s85.138286-190.171429 190.171428-190.171428 190.171429 85.138286 190.171429 190.171428-85.138286 190.171429-190.171429 190.171429z"
                            fill="#000000"
                            p-id="8414"
                          ></path>
                        </svg>
                      </div>
                    </span>
                  </h2>
                  <div
                    class="flex_center_between_box"
                    style="justify-content: start; align-items: end"
                  >
                    <el-select
                      popper-class="common_select"
                      v-model="PerformanceComparisvalue"
                      filterable
                      ref="upSelecttwo"
                      v-click-outside="clickOutSidetwo"
                      placeholder="Select a Year"
                      @change="PerformanceComparisvaluechange()"
                      style="width: 240px; font-size: 20px"
                    >
                      <el-option
                        v-for="(item, index) in reationsoptions"
                        :key="index"
                        :label="item.reportYear"
                        :value="item.reportYear"
                      >
                      </el-option>
                    </el-select>

                    <el-select
                      ref="upSelect"
                      v-show="iconactive == 'table'"
                      v-click-outside="clickOutSide"
                      popper-class="common_select"
                      v-model="Performancevalue"
                      filterable
                      style="margin-left: 20px; width: 230px; font-size: 20px"
                      placeholder="Select a type"
                      @change="SelectPerformanceComparis"
                    >
                      <el-option
                        v-for="(item, index) in PerformanceComparis"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="iconactive == 'computer'">
                    <div class="lable-echarts">
                      <div
                        class="lable-echarts-box"
                        v-for="(item, index) in PerformanceComparis"
                        :key="index"
                        @click="PerformanceComparisLable(item, index)"
                      >
                        <span class="lable-echarts-box-Conent"></span>
                        <span>{{ item.label }}</span>
                      </div>
                      <div class="lable-echarts-box">
                        <span class="lable-echarts-box-Conent"></span>
                        <span>{{ $t("RatingAnalysis.SubjectCompany") }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-show="iconactive == 'table'" class="fivetable">
                    <el-table
                      empty-text="No Data"
                      :data="ProfitabilityRatio"
                      style="width: 100%"
                      :key="Math.round()"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.ProfitabilityRatios')"
                        prop=""
                        width="160"
                        align="left"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Grossmargin')"
                        align="right"
                        prop="grossProfitMargin"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.grossProfitMargin }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Returnonassets')"
                        align="right"
                        prop="returnOnTotalAssets"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.returnOnTotalAssets }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Returnonequity')"
                        align="right"
                        prop="returnOnEquity"
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.returnOnEquity
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!--  -->
                    <el-table
                      empty-text="No Data"
                      :data="ProfitabilityRatio"
                      style="width: 100%"
                      class="td_h_78"
                      :key="Math.round()"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.OperatingRatios')"
                        prop="name"
                        width="160"
                        align="left"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Stockturnover')"
                        align="right"
                        prop="inventoryTurnoverRate"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.inventoryTurnoverRate }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Assetsturnover')"
                        align="right"
                        prop="currentAssetTurnover"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.currentAssetTurnover }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Collectionperiod')"
                        align="right"
                        prop="accountsReceivableTurnoverRate"
                        class="td_h_78"
                      >
                        <template slot-scope="scope">
                          <span>{{
                            scope.row.accountsReceivableTurnoverRate
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table
                      empty-text="No Data"
                      :data="ProfitabilityRatio"
                      style="width: 100%"
                      :key="Math.round()"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.GrowthRatios')"
                        prop="name"
                        width="160"
                        align="left"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Totalassetsgrowthrate')"
                        align="right"
                        prop="totalAssetGrowthRate"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.totalAssetGrowthRate }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Salesgrowthrate')"
                        align="right"
                        prop="revenueGrowthRate"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.revenueGrowthRate }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Netprofitgrowthrate')"
                        align="right"
                        prop="operatingProfitGrowthRate"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.operatingProfitGrowthRate }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table
                      empty-text="No Data"
                      :data="ProfitabilityRatio"
                      style="width: 100%"
                      :key="Math.round()"
                      row-class-name="highlight-row"
                      :cell-class-name="cellClassName"
                    >
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.StructuralRatios')"
                        prop="name"
                        width="160"
                        align="left"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Debtratio')"
                        align="right"
                        prop="assetLiabilityRatio"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.assetLiabilityRatio }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Quickratio')"
                        align="right"
                        prop="quickRatio"
                      >
                        <template slot-scope="scope">
                          <span>{{ scope.row.quickRatio }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('CompetitiveAnalysis.Currentratio')"
                        align="right"
                        prop="currentRatio"
                      >
                        <template slot-scope="scope">
                          <span class="table-content">{{
                            scope.row.currentRatio
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div v-if="iconactive == 'computer'" class="flex-warp">
                    <div style="width: 49%">
                      <div
                        class="flex-warp-item"
                        ref="zhuzhuangtuschart"
                        style="
                          width: 100%;
                          height: 300px;
                          padding-left: 10px;
                          padding-top: 10px;
                        "
                      ></div>
                      <div
                        class="flex-warp-item"
                        ref="zhuzhuangtuschart1"
                        style="
                          width: 100%;
                          height: 400px;
                          padding-left: 10px;
                          padding-top: 10px;
                          margin-top: 10px;
                        "
                      ></div>

                      <div></div>
                    </div>
                    <div style="width: 49%">
                      <div
                        class="flex-warp-item"
                        ref="zhuzhuangtuschart2"
                        style="
                          width: 100%;
                          height: 300px;
                          padding-left: 10px;
                          padding-top: 10px;
                        "
                      ></div>
                      <div
                        class="flex-warp-item"
                        ref="zhuzhuangtuschart3"
                        style="
                          width: 100%;
                          height: 400px;
                          padding-left: 10px;
                          padding-top: 10px;
                          margin-top: 10px;
                        "
                      ></div>

                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import {
  getRatingDistribution,
  getBlockListData,
  getAttrbuteComparison,
  getPerformanceComparison,
  getratingAnalysisCurrent,
} from "@/api/companyApi";
// import topecharts from "./topecharts.vue";
import { mixins1 } from "@/mixins/index";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  mixins: [mixins1],
  //   props: {},

  components: { ReLogin },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getBlockListData();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    $route(to, from) {
      // 在路由变化时执行的代码

      if (
        to.name == "marketAnalysisattributeComparison" ||
        to.name == "marketAnalysisratingAnalysis" ||
        to.name == "marketAnalysisratingDistribution"
      ) {
        this.Attributechart();

        this.$nextTick(() => {
          this.echartsBox.resize(); // 确保图表在可见时调整大小
          this.echartsBox1.resize();
          this.echartsBox2.resize();
          this.echartsBox3.resize();
        });
      }
    },
  },
  data() {
    return {
      reLoginVis: false,
      reationvalue: "",

      reationvalue4: "",
      reationvalue5: "",
      reationvalue6: "",
      Continent: [],
      Country: [],
      Provinces: [],
      Years: [],
      Nature: [],
      Size: [],
      reationsoptions: [],

      reationsoptions6: [],
      creditOpinion: "BBB",
      creditScore: 0.77,
      industryCode: "",
      Busines: "",
      ProductsServices: "",
      options: [],
      YeraOptions: [],
      Comparisvalue: "Average",
      Performancevalue: "Mean",
      Performancevalueone: "Mean",
      Comparisonoptions: [
        {
          value: "Average",
          label: this.$t("CompetitiveAnalysis.Average"),
        },
        {
          value: "Subject company",
          label: this.$t("CompetitiveAnalysis.Subjectcompany"),
        },
      ],
      PerformanceComparis: [],
      AttributeComparison: [],
      IndustryYear: "2024",
      PerformanceComparisvalue: "2024",
      PerformanceComparisvalueone: "2024",
      RatingDistributionyear: "2024",
      value2: "Number of enterprise",
      tableData: [],
      tableDatatwo: [],
      AttributeData: [],
      ProfitabilityData: [
        {
          ProfitabilityRatio: "Average",
          GrossProfitMargin: "20",
          Assets: "10",
          Equity: "20",
        },
        {
          ProfitabilityRatio: "Subject company",
          GrossProfitMargin: "20",
          Assets: "10",
          Equity: "20",
        },
      ],

      ProfitabilityData1: [],

      data: [],
      RatingDistributionData: [],
      RatingDistributionDatatable: [],
      iconactive: "computer",
      iconactive1: "table",
      iconactive2: "computer",
      iconactive3: "computer",
      iconactive3: "computer",
      iconactive4: "computer",
      inputIndex: -1,
      editcontent: "",
      // insertData
      // srcviewscompanydetailsbusinessvueDataStart

      // hangyefenxiKey
      hangyefenxiKey: 0,
      ProfitabilityDatalist: [],
      TargetValue: [],
      ProfitabilityRatio: [],
      OperatingRatio: [],
      GrowthRatio: [],
      StructuralRatio: [],
      maxValue: [],
      minValue: [],
      foundItemone: [],
      PerformanceComparisonCoror: "#80C97A",
      AttributeComparisonColor: "#80C97A",
    };
  },
  mounted() {
    let that = this;

    this.getratingAnalysisCurrent();
    this.$nextTick(() => {
      // 在 DOM 更新后执行代码
      that.industryEchart();
      this.IndustryStatisticschart();
    });
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  computed: {},

  methods: {
    resizeFn() {
      if (this.AttributeData) {
        this.Attributechart();
        this.zhuzhuangtuschart();
      }
    },
    clickOutSide() {
      if (this.$refs.upSelect) {
        this.$refs.upSelect.visible = false;
      }
    },
    clickOutSide3() {
      if (this.$refs.upSelect3) {
        this.$refs.upSelect3.visible = false;
      }
    },
    clickOutSide4() {
      if (this.$refs.upSelect4) {
        this.$refs.upSelect4.visible = false;
      }
    },
    clickOutSidetwo() {
      if (this.$refs.upSelecttwo) {
        this.$refs.upSelecttwo.visible = false;
      }
    },
    PerformanceComparisvalueonechange() {
      this.getAttrbuteComparison();
    },
    PerformanceComparisvaluechange() {
      this.getPerformanceComparison();
    },

    getratingAnalysisCurrent() {
      getratingAnalysisCurrent({
        aaaId: this.$route.query.id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.reationsoptions = res.data.report_year;

            this.reationsoptions6 = res.data.country;
            this.PerformanceComparisvalueone =
              this.RatingDistributionyear =
              this.IndustryYear =
              this.PerformanceComparisvalue =
              this.PerformanceComparisvalueone =
              this.reationvalue =
                res.data.report_year[0].reportYear;

            this.industryCode =
              res.data.currentRatingAnalysisWhere.industryCode;
            this.reationvalue4 = Number(
              res.data.currentRatingAnalysisWhere.companyNatureCode,
            );
            this.reationvalue5 = Number(
              res.data.currentRatingAnalysisWhere.companySizeCode,
            );
            this.companySizeCode = Number(
              res.data.currentRatingAnalysisWhere.companySizeCode,
            );
            this.companyYearsCode =
              res.data.currentRatingAnalysisWhere.companyYearsCode;
            this.reationvalue6 =
              res.data.currentRatingAnalysisWhere.countryCode;
            this.getPerformanceComparison();
            this.getRatingDistribution();
            this.getBlockListData();
            // this.getAttrbuteComparison()
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    // 获取九宫格
    getBlockListData() {
      getBlockListData({
        reportYear: this.PerformanceComparisvalue,
        industryCode: this.industryCode,
        countryCode: this.$route.query.companyCountry,
      }).then((res) => {
        if (res.code == 200) {
          let manManagementSummary = [
            {
              name: this.$t("IndustryStatistics.Country"),
              id: this.$t("IndustryStatistics.Country"),
              num: res.data.country,
            },
            {
              name: this.$t("IndustryStatistics.Industry"),
              id: this.$t("IndustryStatistics.Industry"),
              num: res.data.industry,
            },
            {
              name: this.$t("IndustryStatistics.CompanySize"),
              id: this.$t("IndustryStatistics.CompanySize"),
              num: res.data.size,
            },
            {
              name: this.$t("IndustryStatistics.Liquidity"),
              id: this.$t("IndustryStatistics.Liquidity"),
              num: res.data.liquidity,
            },
            {
              name: this.$t("IndustryStatistics.NoofcoinIndustry"),
              id: this.$t("IndustryStatistics.NoofcoinIndustry"),
              num: res.data.numberOfIndustry,
            },
            {
              name: this.$t("IndustryStatistics.IndustryRating"),
              id: this.$t("IndustryStatistics.IndustryRating"),
              num: res.data.industryRating,
            },
            {
              name: this.$t("IndustryStatistics.Profitability"),
              id: this.$t("IndustryStatistics.Profitability"),
              num: res.data.profitability,
            },
            {
              name: this.$t("IndustryStatistics.Growth"),
              id: this.$t("IndustryStatistics.Growth"),
              num: res.data.growth,
            },
            {
              name: this.$t("IndustryStatistics.FinancialStructurt"),
              id: this.$t("IndustryStatistics.FinancialStructurt"),
              num: res.data.financialStructurt,
            },
            {
              name: this.$t("IndustryStatistics.Repaying"),
              id: this.$t("IndustryStatistics.Repaying"),
              num: res.data.repaying,
            },
          ];
          this.$emit("UpdatamarkTotalList", manManagementSummary);
        } else {
          this.$emit("UpdatamarkTotalList", []);
        }
      });
    },
    // 切换大洲数据
    SelectPerformanceComparis() {
      if (this.Performancevalue == "Mean") {
        this.PerformanceComparisonCoror = "#80C97A";
      }
      if (this.Performancevalue == "Average") {
        this.PerformanceComparisonCoror = "#FF7600";
      }
      if (this.Performancevalue == "Max (10%)") {
        this.PerformanceComparisonCoror = "#685ED1";
      }
      if (this.Performancevalue == "Worst (10%)") {
        this.PerformanceComparisonCoror = "#F283BF";
      }

      const foundItem = this.ProfitabilityDatalist.find(
        (item) => item.attributeName == this.Performancevalue,
      );
      this.TargetValue = this.ProfitabilityDatalist.find(
        (item) => item.attributeName == "Subject company",
      );

      this.TargetValue.name = this.$t("RatingAnalysis.SubjectCompany");
      foundItem.name = this.$t("RatingAnalysis.Average");
      (this.ProfitabilityRatio[0] = foundItem),
        (this.ProfitabilityRatio[1] = this.TargetValue),
        this.$nextTick(() => {
          this.zhuzhuangtuschart();
        });
    },
    PerformanceComparisLable(item, index) {
      this.Performancevalue = item.value;
      this.SelectPerformanceComparis();
    },
    PerformanceComparisLableTwo(item) {
      this.Performancevalueone = item.value;
      this.SelectPerformanceComparisTwo();
    },
    // 雷达图筛选
    SelectPerformanceComparisTwo() {
      if (this.Performancevalueone == "Mean") {
        this.AttributeComparisonColor = "#80C97A";
      }
      if (this.Performancevalueone == "Average") {
        this.AttributeComparisonColor = "#FF7600";
      }
      if (this.Performancevalueone == "Max (10%)") {
        this.AttributeComparisonColor = "#685ED1";
      }
      if (this.Performancevalueone == "Worst (10%)") {
        this.AttributeComparisonColor = "#F283BF";
      }
      this.foundItemone = this.AttributeData.find(
        (item) => item.attributeName == this.Performancevalueone,
      );

      this.$nextTick(() => {
        // 在 DOM 更新后执行代码

        this.Attributechart();
      });
    },
    // 数字千分为
    formatNumber(value) {
      const number = parseFloat(value);
      if (isNaN(number)) {
        return "";
      }

      // 根据数字大小选择单位
      if (number >= 1e9) {
        return this.toThousandSeparator((number / 1e9).toFixed(2)) + "b";
      } else if (number >= 1e6) {
        return this.toThousandSeparator((number / 1e6).toFixed(2)) + "m";
      } else if (number >= 1e3) {
        return this.toThousandSeparator((number / 1e3).toFixed(2)) + "k";
      } else {
        return this.toThousandSeparator(number.toString());
      }
    },
    toThousandSeparator(numStr) {
      // 使用正则表达式为数字添加千分位
      const parts = numStr.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },

    getPerformanceComparison() {
      getPerformanceComparison({
        aaaId: this.$route.query.id3a,
        reportYear: this.PerformanceComparisvalue,
        industryCode: this.industryCode,
        countryCode: this.$route.query.companyCountry,
      }).then((res) => {
        if (res.code == 200 && res.data.length > 0) {
          this.PerformanceComparis = [];
          res.data.map((item) => {
            if (item.attributeName != "Subject company") {
              this.PerformanceComparis.push({
                label: item.attributeName,
                value: item.attributeName,
              });
            }
          });
          this.ProfitabilityDatalist = res.data;
          this.getAttrbuteComparison();
          // this.SelectPerformanceComparis()
        } else {
          this.ProfitabilityDatalist = [];
          this.getAttrbuteComparison();
        }
      });
    },
    // Attribute Comparison

    getAttrbuteComparison() {
      // aaaId:this.$route.query.id3a,
      // reportYear:this.PerformanceComparisvalue,
      getAttrbuteComparison({
        aaaId: this.$route.query.id3a,
        reportYear: this.PerformanceComparisvalueone,
        industryCode: this.industryCode,
        countryCode: this.$route.query.companyCountry,
      }).then((res) => {
        if (res.code == 200) {
          this.AttributeData = res.data.attrvalueComparisonTable;
          this.maxValue = res.data.max;
          this.maxValue.employee = Math.log(Math.abs(this.maxValue.employee));
          this.maxValue.netAssets = Math.log(Math.abs(this.maxValue.netAssets));
          this.maxValue.netProfit = Math.log(Math.abs(this.maxValue.netProfit));
          this.maxValue.totalAssets = Math.log(
            Math.abs(this.maxValue.totalAssets),
          );
          this.maxValue.turnover = Math.log(Math.abs(this.maxValue.turnover));

          this.minValue = res.data.min;
          this.minValue.employee = Math.log(Math.abs(this.minValue.employee));
          if (this.minValue.netAssets < 0) {
            this.minValue.netAssets = -Math.log(
              Math.abs(this.minValue.netAssets),
            );
          } else {
            this.minValue.netAssets = Math.log(
              Math.abs(this.minValue.netAssets),
            );
          }
          if (this.minValue.netProfit < 0) {
            this.minValue.netProfit = -Math.log(
              Math.abs(this.minValue.netProfit),
            );
          } else {
            this.minValue.netProfit = Math.log(
              Math.abs(this.minValue.netProfit),
            );
          }
          if (this.minValue.totalAssets < 0) {
            this.minValue.totalAssets = -Math.log(
              Math.abs(this.minValue.totalAssets),
            );
          } else {
            this.minValue.totalAssets = Math.log(
              Math.abs(this.minValue.totalAssets),
            );
          }
          if (this.minValue.turnover < 0) {
            this.minValue.turnover = -Math.log(
              Math.abs(this.minValue.turnover),
            );
          } else {
            this.minValue.turnover = Math.log(Math.abs(this.minValue.turnover));
          }
          this.SelectPerformanceComparisTwo();
          this.SelectPerformanceComparis();

          // this.$nextTick(() => {
          //   // 在 DOM 更新后执行代码

          //   this.Attributechart();
          // });
        } else {
          this.AttributeData = [];
        }
      });
    },
    // Rating Distribution年份更改
    RatingDistributionyearchange() {
      this.getRatingDistribution();
    },
    getRatingDistribution() {
      // id3a: this.$route.query.id3a,

      let params = {
        reportYear: this.RatingDistributionyear,
        industryCode: this.industryCode,
        countryCode: this.$route.query.companyCountry,
        companySizeCode: this.companySizeCode,
        aaaId: this.$route.query.id3a,
        companyYearsCode: this.companyYearsCode,
      };
      getRatingDistribution(params).then((res) => {
        if (res.code == 200) {
          this.RatingDistributionDatatable = res.data.table;
          this.RatingDistributionData = res.data.chart;

          this.$nextTick(() => {
            // 在 DOM 更新后执行代码
            this.riskEchart();
          });
        } else {
          this.RatingDistributionData = [];
        }
      });
    },
    riskEchart() {
      const that = this;
      const option = {
        grid: {
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,

            center: ["50%", "75%"],
            radius: "146%",
            // radius: '145%',
            clockwise: true,
            show: true,
            min: 0,
            max: 1,
            splitNumber: 5,

            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 20,

                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },

            pointer: {
              icon: "circle",

              length: "20%",
              width: 22,
              offsetCenter: [0, "-85%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 5,
              distance: -28,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            // 刻度线
            splitLine: {
              show: false,
              length: 10,
              // distance:-20,
              lineStyle: {
                color: "auto",
                width: 8,
              },
            },
            axisLabel: {
              show: false,
              rotate: "tangential",
              fontWeight: "normal",
              fontSize: 0,
              distance: -62,
              width: 70,
              height: 40,
              fontFamily: "Arial",
              overflow: "truncate",
              color: [
                [
                  0.25,
                  {
                    type: "linear",

                    x: 0,

                    y: 10,

                    x2: 30,

                    y2: 11,

                    colorStops: [
                      {
                        offset: 1,
                        color: "#F56B6BFF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  0.5,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#FA6666FF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  1,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#55B419FF",
                      },
                    ],

                    global: false,
                  },
                ],
              ],

              formatter: function (value) {
                if (value === 1) {
                  return "Low Risk";
                } else if (value === 0.8) {
                  return "Lower Than Avg.";
                } else if (value === 0.6) {
                  return "Average";
                } else if (value === 0.4) {
                  return "Moderate";
                } else if (value === 0.2) {
                  return "Medium";
                } else if (value === 0.0) {
                  return "High Risk";
                }
                return "";
              },
            },

            title: {
              offsetCenter: [0, "20%"],
              fontSize: 15,
              color: "#ccc",
            },
            // 仪表盘数字
            detail: {
              lineHeight: 126,
              fontSize: 35,
              offsetCenter: [1, "-22"],
              valueAnimation: true,
              borderColor: "#55B419FF",
              width: 200,
              formatter: function (value) {
                var a = "d";
                if (Math.round(value * 100)) {
                  a = "A";
                }
                return that.RatingDistributionData[0]
                  ?.targetCompanyCreditOpinion;
              },
              color: "#55B419FF",
            },
            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[0]?.targetCompanyCreditScore,
                  ) / 100,
                // name: "Credit Opinion",
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "96%",
            min: 0,
            max: 1,

            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: [
                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },
            pointer: {
              icon: "triangle",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-105%"],
              itemStyle: {
                color: "#55B419FF",
              },
            },

            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[0]?.targetCompanyCreditScore,
                  ) / 100,
                detail: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      const option1 = {
        grid: {
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,

            center: ["50%", "75%"],
            radius: "146%",
            // radius: '145%',
            clockwise: true,
            show: true,
            min: 0,
            max: 1,
            splitNumber: 5,

            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 20,

                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },

            pointer: {
              icon: "circle",

              length: "20%",
              width: 22,
              offsetCenter: [0, "-85%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 5,
              distance: -28,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            // 刻度线
            splitLine: {
              show: false,
              length: 10,
              // distance:-20,
              lineStyle: {
                color: "auto",
                width: 8,
              },
            },
            axisLabel: {
              show: false,
              rotate: "tangential",
              fontWeight: "normal",
              fontSize: 0,
              distance: -62,
              width: 70,
              height: 40,
              fontFamily: "Arial",
              overflow: "truncate",
              color: [
                [
                  0.25,
                  {
                    type: "linear",

                    x: 0,

                    y: 10,

                    x2: 30,

                    y2: 11,

                    colorStops: [
                      {
                        offset: 1,
                        color: "#F56B6BFF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  0.5,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#FA6666FF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  1,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#55B419FF",
                      },
                    ],

                    global: false,
                  },
                ],
              ],

              formatter: function (value) {
                if (value === 1) {
                  return "Low Risk";
                } else if (value === 0.8) {
                  return "Lower Than Avg.";
                } else if (value === 0.6) {
                  return "Average";
                } else if (value === 0.4) {
                  return "Moderate";
                } else if (value === 0.2) {
                  return "Medium";
                } else if (value === 0.0) {
                  return "High Risk";
                }
                return "";
              },
            },

            title: {
              offsetCenter: [0, "20%"],
              fontSize: 15,
              color: "#ccc",
            },
            // 仪表盘数字
            detail: {
              lineHeight: 126,
              fontSize: 35,
              offsetCenter: [1, "-22"],
              valueAnimation: true,

              borderColor: "#55B419FF",

              width: 200,
              formatter: function (value) {
                var a = "d";
                if (Math.round(value * 100)) {
                  a = "A";
                }
                return that.RatingDistributionData[1]
                  ?.targetCompanyCreditOpinion;
              },
              color: "#55B419FF",
            },
            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[1]?.targetCompanyCreditScore,
                  ) / 100,
                // name: "Credit Opinion",
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "96%",
            min: 0,
            max: 1,

            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: [
                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },
            pointer: {
              icon: "triangle",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-105%"],
              itemStyle: {
                color: "#55B419FF",
              },
            },

            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[1]?.targetCompanyCreditScore,
                  ) / 100,
                detail: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      const option2 = {
        grid: {
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,

            center: ["50%", "75%"],
            radius: "146%",
            // radius: '145%',
            clockwise: true,
            show: true,
            min: 0,
            max: 1,
            splitNumber: 5,

            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 20,

                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },

            pointer: {
              icon: "circle",

              length: "20%",
              width: 22,
              offsetCenter: [0, "-85%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 5,
              distance: -28,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            // 刻度线
            splitLine: {
              show: false,
              length: 10,
              // distance:-20,
              lineStyle: {
                color: "auto",
                width: 8,
              },
            },
            axisLabel: {
              show: false,
              rotate: "tangential",
              fontWeight: "normal",
              fontSize: 0,
              distance: -62,
              width: 70,
              height: 40,

              fontFamily: "Arial",
              overflow: "truncate",
              color: [
                [
                  0.25,
                  {
                    type: "linear",

                    x: 0,

                    y: 10,

                    x2: 30,

                    y2: 11,

                    colorStops: [
                      {
                        offset: 1,
                        color: "#F56B6BFF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  0.5,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#FA6666FF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  1,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#55B419FF",
                      },
                    ],

                    global: false,
                  },
                ],
              ],

              formatter: function (value) {
                if (value === 1) {
                  return "Low Risk";
                } else if (value === 0.8) {
                  return "Lower Than Avg.";
                } else if (value === 0.6) {
                  return "Average";
                } else if (value === 0.4) {
                  return "Moderate";
                } else if (value === 0.2) {
                  return "Medium";
                } else if (value === 0.0) {
                  return "High Risk";
                }
                return "";
              },
            },

            title: {
              offsetCenter: [0, "20%"],
              fontSize: 15,
              color: "#ccc",
            },
            // 仪表盘数字
            detail: {
              lineHeight: 126,
              fontSize: 35,
              offsetCenter: [1, "-22"],
              valueAnimation: true,

              borderColor: "#55B419FF",

              width: 200,
              formatter: function (value) {
                var a = "d";
                if (Math.round(value * 100)) {
                  a = "A";
                }
                return that.RatingDistributionData[2]
                  ?.targetCompanyCreditOpinion;
              },
              color: "#55B419FF",
            },
            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[2]?.targetCompanyCreditScore,
                  ) / 100,
                // name: "Credit Opinion",
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "96%",
            min: 0,
            max: 1,

            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: [
                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },
            pointer: {
              icon: "triangle",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-105%"],
              itemStyle: {
                color: "#55B419FF",
              },
            },

            data: [
              {
                value:
                  Number(
                    that.RatingDistributionData[2]?.targetCompanyCreditScore,
                  ) / 100,
                detail: {
                  show: false,
                },
              },
            ],
          },
        ],
      };

      this.riskChart = this.$echarts.init(this.$refs.riskRef);
      this.riskChart1 = this.$echarts.init(this.$refs.riskRef1);
      this.riskChart2 = this.$echarts.init(this.$refs.riskRef2);
      // this.riskChart.dispose()
      // this.riskChart1.dispose()
      // this.riskChart2.dispose()
      this.riskChart.setOption(option);
      this.riskChart1.setOption(option1);
      this.riskChart2.setOption(option2);
    },
    zhuhuangcehartsi() {
      this.iconactive = "computer";

      this.$nextTick(() => {
        // 在 DOM 更新后执行代码

        this.zhuzhuangtuschart();
      });
    },
    getProgress(item) {
      try {
        let tempData = item.rate.replace("%", "");
        if (tempData > 0 && tempData <= 100) {
          return Number(tempData);
        } else {
          return 0;
        }
      } catch (error) {
        return 0;
      }
    },
    CancelAdd() {
      this.inputIndex = -1;
      this.tableData.pop();
    },
    edit(content) {
      this.editcontent = content;

      //   this.tableData.push({ ...this.tableData[index-1] });
    },
    // insertMethod
    // srcviewscompanydetailsbusinessvueMethodStart
    // returnPage

    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },
    addInput(index) {
      this.inputIndex = index;
      this.tableData.push({ ...this.tableData[index - 1] });
    },
    industryEchart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);
      //   this.$echarts.registerTransform(ecStat.transform.clustering)

      const data = [
        [
          [28604, 77, 17096869, "2011"],
          [31163, 77.4, 27662440, "2012"],
          [1516, 68, 1154605773, "2012"],
        ],
        [
          [44056, 81.8, 23968973, "2012"],
          [43294, 81.7, 35939927, "2012"],
          [13334, 76.9, 1376048943, "2012"],
          [21291, 78.5, 11389562, "2012"],
        ],
      ];
      let option = {
        legend: {
          right: "1%",
          top: "1%",
          data: ["pro", "inc"],
        },
        grid: {
          left: "5%",
          right: "3%",
          top: "5%",
          bottom: "4%",
        },
        xAxis: {
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          scale: true,
        },
        series: [
          {
            name: "pro",
            data: data[0],
            type: "scatter",
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
              focus: "series",
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: "top",
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(120, 36, 50, 0.5)",
              shadowOffsetY: 5,
            },
          },
          {
            name: "inc",
            data: data[1],
            type: "scatter",
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 5e2;
            },
            emphasis: {
              focus: "series",
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: "top",
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(25, 100, 150, 0.5)",
              shadowOffsetY: 5,
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },
    IndustryStatisticschart() {
      let that = this;
      this.echartsBox = this.$echarts.init(this.$refs.IndustryStatisticschart);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              "Insurance Services",
              "Less Than 3 Years",
              "Large Companies",
              "China",
              "BB+",
            ],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Direct",
            type: "bar",
            barWidth: "60%",
            data: [10000, 5000, 5000, 5000, 5000, 5000, 5000],
            barWidth: "80px", // 柱子宽度
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },
    zhuzhuangtuschart() {
      this.echartsBox = this.$echarts.init(this.$refs.zhuzhuangtuschart);
      this.echartsBox1 = this.$echarts.init(this.$refs.zhuzhuangtuschart1);
      this.echartsBox2 = this.$echarts.init(this.$refs.zhuzhuangtuschart2);
      this.echartsBox3 = this.$echarts.init(this.$refs.zhuzhuangtuschart3);
      let option = {
        title: {
          //标题组件
          show: "true",
          text: "Profitability Ratios",
          extstyle: {
            //主标题文本样式
            color: "blue",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "5%", //距离dom间距
          right: "4%",
          top: "15%",
          bottom: "1%",
        },

        xAxis: [
          {
            type: "value",
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            max: 2,
            splitLine: { show: false },
            axisLabelGap: 1,

            gap: 1,
            inverse: true,
            axisLabel: {
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 10, 35, 10],
              textStyle: {
                fontSize: 12,
                color: "black",
              },
            },
            nameGap: 2,
            // 纵坐标数据
            data: [
              "Gross margin  (%)",
              "Return on assets  (%)",
              "Return on equity  (%)",
            ],
            yAxisIndex: 0,
            // 横坐标 分割线等取消显示
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              inside: false,
              verticalAlign: "bottom",
              // 位置 上右下左
              padding: [0, 10, 10, -40],
              //   lineHeight: "40",
              textStyle: {
                fontSize: 12,
                color: "black",
                fontFamily: "SourceHanSansCN-Regular",
              },
            },
            // 统计的总量 用纵坐标模拟
            data: [1, 1, 1],
          },
        ],
        series: [
          {
            name: this.Performancevalue,
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量1",
            showBackground: true,
            // 全部背景

            data: [
              this.ProfitabilityRatio[0].grossProfitMargin,
              this.ProfitabilityRatio[0].returnOnTotalAssets,
              this.ProfitabilityRatio[0].returnOnEquity,
            ],
            barCategoryGap: "0%",
            itemStyle: {
              color: this.PerformanceComparisonCoror, // 柱子颜色
            },
          },
          {
            name: "Subject company",
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量2",
            showBackground: true,
            // 全部背景

            barGap: "1%",
            barCategoryGap: "0%",
            data: [
              this.ProfitabilityRatio[1].grossProfitMargin,
              this.ProfitabilityRatio[1].returnOnTotalAssets,
              this.ProfitabilityRatio[1].returnOnEquity,
            ],
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      let option1 = {
        title: {
          //标题组件
          show: "true",
          text: "Growth Ratios",
          extstyle: {
            //主标题文本样式
            color: "blue",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "5%", //距离dom间距
          right: "4%",
          top: "15%",
          bottom: "1%",
        },

        xAxis: [
          {
            type: "value",
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            max: 2,
            splitLine: { show: false },
            axisLabelGap: 1,

            gap: 1,
            inverse: true,
            axisLabel: {
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 10, 35, 10],
              textStyle: {
                fontSize: 12,
                color: "black",
              },
            },
            nameGap: 2,
            // 纵坐标数据
            data: [
              "Total assets growth rate  (%)",
              "Sales growth rate  (%)",
              "Net profit growth rate  (%)",
            ],
            yAxisIndex: 0,
            // 横坐标 分割线等取消显示
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              inside: false,
              verticalAlign: "bottom",
              // 位置 上右下左
              padding: [0, 10, 10, -40],
              //   lineHeight: "40",
              textStyle: {
                fontSize: 12,
                color: "black",
                fontFamily: "SourceHanSansCN-Regular",
              },
            },
            // 统计的总量 用纵坐标模拟
            data: [1, 1, 1],
          },
        ],
        series: [
          {
            name: this.Performancevalue,
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量1",
            showBackground: true,
            // 全部背景

            data: [
              this.ProfitabilityRatio[0].totalAssetGrowthRate,
              this.ProfitabilityRatio[0].revenueGrowthRate,
              this.ProfitabilityRatio[0].operatingProfitGrowthRate == null
                ? 0
                : this.ProfitabilityRatio[0].operatingProfitGrowthRate,
            ],
            barCategoryGap: "0%",
            itemStyle: {
              color: this.PerformanceComparisonCoror, // 柱子颜色
            },
          },
          {
            name: "Subject company",
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量2",
            showBackground: true,
            // 全部背景

            barGap: "1%",
            barCategoryGap: "0%",
            data: [
              this.ProfitabilityRatio[1].totalAssetGrowthRate,
              this.ProfitabilityRatio[1].revenueGrowthRate,
              this.ProfitabilityRatio[1].operatingProfitGrowthRate == null
                ? 0
                : this.ProfitabilityRatio[1].operatingProfitGrowthRate,
            ],
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      let option2 = {
        title: {
          //标题组件
          show: "true",
          text: "Operating Ratios",
          extstyle: {
            //主标题文本样式
            color: "blue",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "5%", //距离dom间距
          right: "4%",
          top: "15%",
          bottom: "1%",
        },
        // legend:{
        //       data:['Average Value','Target Company'],
        //       textStyle:{
        //           color:'black',
        //       },
        //       x:'right',
        //       y: '1%',
        //   },
        xAxis: [
          {
            type: "value",
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            max: 3,
            splitLine: { show: false },
            axisLabelGap: 1,

            gap: 1,
            inverse: true,
            axisLabel: {
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 10, 35, 10],
              textStyle: {
                fontSize: 12,
                color: "black",
              },
            },
            nameGap: 2,
            // 纵坐标数据
            data: [
              "Stock turnover  (x)",
              "Assets turnover  (x)",
              "Current asset turnover rate",
              "Collection period  (days)",
            ],
            yAxisIndex: 0,
            // 横坐标 分割线等取消显示
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              inside: false,
              verticalAlign: "bottom",
              // 位置 上右下左
              padding: [0, 10, 10, -40],
              //   lineHeight: "40",
              textStyle: {
                fontSize: 12,
                color: "black",
                fontFamily: "SourceHanSansCN-Regular",
              },
            },
            // 统计的总量 用纵坐标模拟
            data: [1, 1, 1, 1],
          },
        ],
        series: [
          {
            name: this.Performancevalue,
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量1",
            showBackground: true,
            // 全部背景

            data: [
              this.ProfitabilityRatio[0].inventoryTurnoverRate == null
                ? 0
                : this.ProfitabilityRatio[0].inventoryTurnoverRate,
              this.ProfitabilityRatio[0].totalAssetTurnoverRate,
              (this.ProfitabilityRatio[0].currentAssetTurnover = null
                ? 0
                : this.ProfitabilityRatio[0].currentAssetTurnover),
              (this.ProfitabilityRatio[0].accountsReceivableTurnoverRate = null
                ? 0
                : this.ProfitabilityRatio[0].accountsReceivableTurnoverRate),
            ],
            barCategoryGap: "0%",
            itemStyle: {
              color: this.PerformanceComparisonCoror, // 柱子颜色
            },
          },
          {
            name: "Subject company",
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量2",
            showBackground: true,
            // 全部背景

            barGap: "1%",
            barCategoryGap: "0%",
            data: [
              this.ProfitabilityRatio[1].inventoryTurnoverRate == null
                ? 0
                : this.ProfitabilityRatio[1].inventoryTurnoverRate,
              this.ProfitabilityRatio[1].totalAssetTurnoverRate,
              (this.ProfitabilityRatio[1].currentAssetTurnover = null
                ? 0
                : this.ProfitabilityRatio[1].currentAssetTurnover),
              (this.ProfitabilityRatio[1].accountsReceivableTurnoverRate = null
                ? 0
                : this.ProfitabilityRatio[1].accountsReceivableTurnoverRate),
            ],
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      let option3 = {
        title: {
          //标题组件
          show: "true",
          text: "Structural Ratios",
          extstyle: {
            //主标题文本样式
            color: "blue",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "5%", //距离dom间距
          right: "4%",
          top: "15%",
          bottom: "1%",
        },
        // legend:{
        //       data:['Average Value','Target Company'],
        //       textStyle:{
        //           color:'black',
        //       },
        //       x:'right',
        //       y: '1%',
        //   },
        xAxis: [
          {
            type: "value",
            boundaryGap: true,
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            max: 2,
            splitLine: { show: false },
            axisLabelGap: 1,

            gap: 1,
            inverse: true,
            axisLabel: {
              verticalAlign: "bottom",
              align: "left",
              padding: [0, 10, 35, 10],
              textStyle: {
                fontSize: 12,
                color: "black",
              },
            },
            nameGap: 2,
            // 纵坐标数据
            data: [
              "Debt  ratio  (%)",
              "Quick ratio  (x)",
              "Current ratio  (x)",
            ],
            yAxisIndex: 0,
            // 横坐标 分割线等取消显示
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              inside: false,
              verticalAlign: "bottom",
              // 位置 上右下左
              padding: [0, 10, 10, -40],
              //   lineHeight: "40",
              textStyle: {
                fontSize: 12,
                color: "black",
                fontFamily: "SourceHanSansCN-Regular",
              },
            },
            // 统计的总量 用纵坐标模拟
            data: [1, 1, 1],
          },
        ],
        series: [
          {
            name: this.Performancevalue,
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量1",
            showBackground: true,
            // 全部背景

            data: [
              this.ProfitabilityRatio[0].assetLiabilityRatio == null
                ? 0
                : this.ProfitabilityRatio[0].assetLiabilityRatio,
              this.ProfitabilityRatio[0].quickRatio == null
                ? 0
                : this.ProfitabilityRatio[0].quickRatio,
              this.ProfitabilityRatio[0].currentRatio == null
                ? 0
                : this.ProfitabilityRatio[0].currentRatio,
            ],
            barCategoryGap: "0%",
            itemStyle: {
              color: this.PerformanceComparisonCoror, // 柱子颜色
            },
          },
          {
            name: "Subject company",
            type: "bar",
            // 宽度
            barWidth: "15",
            // 堆叠
            stack: "总量2",
            showBackground: true,
            // 全部背景

            barGap: "1%",
            barCategoryGap: "0%",
            data: [
              this.ProfitabilityRatio[1].assetLiabilityRatio == null
                ? 0
                : this.ProfitabilityRatio[1].assetLiabilityRatio,
              this.ProfitabilityRatio[1].quickRatio == null
                ? 0
                : this.ProfitabilityRatio[1].quickRatio,
              this.ProfitabilityRatio[1].currentRatio == null
                ? 0
                : this.ProfitabilityRatio[1].currentRatio,
            ],
            itemStyle: {
              color: "#1290C9", // 柱子颜色
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.echartsBox1.setOption(option2);
      this.echartsBox2.setOption(option1);
      this.echartsBox3.setOption(option3);
      this.echartsBox.resize();
      this.echartsBox1.resize();
      this.echartsBox2.resize();
      this.echartsBox3.resize();
    },
    // 雷达图
    Attributechart() {
      let that = this;
      console.log(this.maxValue);

      this.AttributeData.map((item) => {
        item.employeeMth = Math.log(Math.abs(item.employee));
        item.netAssetsMth = Math.log(Math.abs(item.netAssets));
        item.netProfitMth = Math.log(Math.abs(item.netProfit));
        item.totalAssetsMth = Math.log(Math.abs(item.totalAssets));
        item.turnoverMth = Math.log(Math.abs(item.turnover));
        // if (item.attributeName == "Subject company") {
        //   targetdata = item
        // }
      });

      let leidaDate = [];
      console.log("this.AttributeData", this.minValue);
      this.AttributeData.map((item) => {
        leidaDate.push({
          value: [
            item.turnoverMth,
            item.employeeMth,
            item.netProfitMth,
            item.totalAssetsMth,
            item.netAssetsMth,
          ],
          name: item.attributeName,
          valueTrue: [
            this.formatNumber(item.turnover),
            this.formatNumber(item.employee),
            this.formatNumber(item.netProfit),
            this.formatNumber(item.totalAssets),
            this.formatNumber(item.netAssets),
          ],
        });
      });
      console.log("leidaDate", leidaDate);

      this.echartsBox = this.$echarts.init(this.$refs.Attributechart);

      let option = {
        color: ["#80C97A", "#FF7600", "#685ED1", "#F283BF", "#1290C9"],
        grid: {
          left: "4%", // 设置左侧边距为0
          right: "4%", // 设置右侧边距为0
          top: "4%", // 设置上边距为0
          bottom: "0%", // 设置下边距为0
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              "Revenue: " +
              params.data.valueTrue[0] +
              "<br/>" +
              "Employees: " +
              params.data.valueTrue[1] +
              "<br/>" +
              "Net Earnings: " +
              params.data.valueTrue[2] +
              "<br/>" +
              "Total Assets: " +
              params.data.valueTrue[3] +
              "<br/>" +
              "Net Assets: " +
              params.data.valueTrue[4] +
              "<br/>"
            );
          },
        },

        legend: {
          data: this.AttributeData.map((item) => item.attributeName),
          right: "10%",
          top: "3%",
          textStyle: {
            color: "#1a2332",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        radar: {
          axisName: {
            color: "#1A2332", // 设置字体颜色
            fontSize: 12, // 可以在这里设置字体大小
            fontWeight: "normal", // 字体粗细
            fontFamily: "Arial, Arial", // 字体类型,
          },
          // shape: 'circle',
          indicator: [
            {
              name: "Revenue",
              max: that.maxValue.turnover,
              min: this.minValue?.turnover,
              fontSize: 12,
            },
            {
              name: "Employees",
              max: that.maxValue.employee,
              min: this.minValue?.employee,
              fontSize: 12,
            },
            {
              name: "Net Earnings",
              max: that.maxValue.netProfit,
              min: this.minValue?.netProfit,
              fontSize: 12,
            },
            {
              name: "Total Assets",
              max: that.maxValue.totalAssets,
              min: this.minValue?.totalAssets,
              fontSize: 12,
            },
            {
              name: "Net Assets",
              max: that.maxValue.netAssets,
              min: this.minValue?.netAssets,
              fontSize: 12,
            },
          ],
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            axisLabel: {
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
            },
            data: leidaDate,
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.echartsBox.resize();
    },
    // srcviewscompanydetailsbusinessvueMethodEnd
  },
};
</script>
<style scoped>
.ua915f {
  margin-right: 0em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  margin-top: 0em;
  margin-left: 0em;
  margin-bottom: 0em;
}

.operations-content {
  background: #ffffff;
    border-radius: 10px;

}

.operations-box {
  display: flex;
  justify-content: space-between;
}

/deep/.el-descriptions__title {
  font-size: 1.857142857143rem;
  font-family: "Arial Bold";
  color: #1a2332;
  text-align: left;
  font-style: normal;
}

/deep/ .el-descriptions-item__label {
  display: block !important;
  margin-right: 2.142857142857143rem !important;
  /* padding-bottom: 2.142857142857143rem !important; */
}

.operations-label-title {
  width: max-content;
  font-size: 1.285714285714286rem;
  font-family: "Arial Bold";
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.operations-label-text {
  font-size: 1.285714285714286rem;

  color: #29445d;
  line-height: 1.8571428571428572rem;
  width: 100%;
}

/deep/ .el-textarea__inner {
  font-size: 1.4285714285714286rem;
  color: #29445d;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.operations-box-left {
  /* margin-right: 4.285714285714286rem; */
  /* width: 45%; */
  width: 100%;
  background: #ffffff;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 2.142857142857143rem 2.857142857142857rem;
  height: 100%;
}

.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.4285714285714286rem;
  /* font-size: 1.25em; */
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
  height: 50px;
  background: #f5f5f5;
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding: 2px;
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

.icon {
  margin: 0 1.4285714285714286rem;
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table .cell {
  color: #1a2332;
  line-height: 2.142857142857143rem;
  word-break: keep-all;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}

/deep/ .el-table {
  margin-top: 1.4285714285714286rem;
}

.fivetable /deep/ .el-table {
  margin-top: 1.4285714285714286rem;
}

.operations-center-right /deep/ .el-table {
  margin-top: 1.4285714285714286rem;
  height: 97%;
}

.operations-center-right .table-content {
  line-height: 2.142857142857143rem !important;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.operations-box-right {
  /* width:42.857142857142854rem; */
  height: 100%;
}

.svgbg {
  background-color: #ffffff;
}

.svgclass {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 44px;
  border-radius: 22px;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.line_step {
  /* margin-bottom: 2.142857142857143rem; */
  margin-bottom: 2rem;
  font-size: 1.1428571428571428rem;
  color: #8497ab;
}

.line_step .line_title {
  display: inline-block;
  /* width: 9.857142857142858rem; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2857142857142858rem;

  text-decoration-line: underline;
}

.blue_num {
  display: block;
  text-align: right;
  color: #8497ab;
}

.blue_numon {
  color: #1290c9;
}

.line_step /deep/.el-progress {
  margin-top: 0.7142857142857143rem;
}

.TopPorts {
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  /* height: 3.142857142857143rem; */
  margin-bottom: 1.4285714285714286rem;
}

.operations-center-left {
  padding: 1.4285714285714286rem;
  background-color: #f5f5f5;
  margin-top: 1.4285714285714286rem;
  padding-bottom: 0rem;
  overflow: scroll;
  width: 0;
  flex: auto;
}

.operations-center-item {
  width: 11.428571428571429rem;
  /* margin: 0 1.2857142857142858rem; */
}

.Attribute-left .table-content {
  display: block;
  height: 172px !important;
  line-height: 172px;
}

.flex-warp {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 1.4285714285714286rem;
  width: 100%;
}

.flex-warp-item {
  /* width: 49%; */
  background-color: #f5f5f5;
}

.echarts {
  width: 30.714285714285715rem;
  height: 17.857142857142858rem;
  margin: auto;
}

.table_box {
  position: relative;
  margin-top: 2.142857142857143rem;
}

.aaa {
  font-size: 0.7142857142857143rem;
  color: #fa6666;
  position: absolute;
  left: 10%;
  top: 14.285714285714286rem;
}

.bbb {
  font-size: 0.7142857142857143rem;
  color: #fa755c;
  position: absolute;
  left: 8%;
  top: 6.071428571428571rem;
}

.ccc {
  font-size: 0.7142857142857143rem;
  color: #fc9249;
  position: absolute;
  left: 20%;
  top: 0.5714285714285714rem;
}

.ddd {
  font-size: 0.7142857142857143rem;
  color: #ffd81a;
  position: absolute;
  left: 70%;
  top: 0.5714285714285714rem;
}

.fff {
  font-size: 0.7142857142857143rem;
  color: #aec918;
  position: absolute;
  width: 3.642857142857143rem !important;
  height: 2.142857142857143rem;
  top: 6.071428571428571rem;
  left: 83%;
}

.ggg {
  font-size: 0.7142857142857143rem;
  color: #63b819;
  position: absolute;
  left: 81%;

  top: 14.285714285714286rem;
}

.hhh {
  font-size: 1.4285714285714286rem;
  color: #8497ab;
  position: absolute;
  left: 35%;
  top: 14.285714285714286rem;
}

.jjj {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  position: absolute;
  left: 36%;
  top: 16.428571428571427rem;
}

.Create-titel {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  text-align: center;
}

.table {
  text-align: center;
  margin-top: 1.4285714285714286rem;
  background-color: #f5f5f5;
  padding-top: 2.142857142857143rem;
  margin: auto;
  height: 25.714285714285715rem;
}

.el-table .el-table__cell {
  padding: 0.8571428571428571rem 0;
}

.ecahrtstu {
  width: 32.5%;
}

.ecahrtstu-li {
  width: 49%;
  background-color: #f5f5f5;
  text-align: center;

  padding: 2.142857142857143rem 0rem;
  margin-top: 0.7142857142857143rem;
}

.ecahrtstu-title {
  display: block;
  font-size: 3.5714285714285716rem;
  color: #93c623;
  line-height: 4rem;
}

.ecahrtst-text {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  margin-top: 1.1428571428571428rem;
}

/deep/ .el-table .cell {
  padding-left: 1.0714285714285714rem !important;
  padding-right: 1.0714285714285714rem !important;
}

.TopPorts /deep/ .el-select .el-input__inner {
  border: none !important;
  background-color: transparent !important;
  padding-left: 0rem;
}

/deep/ .el-table .el-table__cell {
  padding: 0.35714285714285715rem 0;
}

/deep/ .el-table .el-table__cell {
  padding: 0;
}
.lable-echarts {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}
.lable-echarts-box {
  display: flex;
  font-size: 1rem;
  align-items: center;
}
.lable-echarts-box-Conent {
  display: block;
  width: 25px;
  height: 15px;
  background: #80c97a;
  border-radius: 4px;
  margin-left: 10px;
  margin-right: 10px;

  cursor: pointer;
}
.lable-echarts-box:nth-child(2) .lable-echarts-box-Conent {
  background: #ff7600;
}
.lable-echarts-box:nth-child(3) .lable-echarts-box-Conent {
  background: #685ed1;
}
.lable-echarts-box:nth-child(4) .lable-echarts-box-Conent {
  background: #f283bf;
}
.lable-echarts-box:nth-child(5) .lable-echarts-box-Conent {
  background: #1290c9;
}
/* .lable-echarts-box:nth-child(1) .lable-echarts-box-Conent{
  background: #F283BF;
} */

.other_lab {
  font-size: 20px;
  margin-left: 20px;
}
.icon_size {
  height: 28px;
}
@media screen and (max-width: 1920px) {
  .other_lab {
    font-size: 16px;
    margin-left: 16px;
  }
  .contclass {
    height: 38px;
  }
  .svgclass {
    height: 33px;
    border-radius: 16px;
  }
  .icon_size {
    height: 24px;
  }
  .Attribute-left .table-content {
    height: 130px !important;
    line-height: 130px;
  }
  .el-table .el-table__header-wrapper .cell {
    font-size: 16px !important;
  }
  .el-table__cell {
    height: 44px !important;
  }
  .table-content {
    font-size: 16px !important;
  }

  .el-table td.el-table__cell {
    height: 60px !important;
  }
  .td_h_78 {
    height: 78px;
  }
}

@media screen and (max-width: 1439px) {
  .other_lab {
    font-size: 14px;
    margin-left: 14px;
  }
  .contclass {
    height: 34px;
  }
  .svgclass {
    height: 30px;
    border-radius: 15px;
  }
  .icon_size {
    height: 18px;
  }
  .Attribute-left .table-content {
    height: 116px !important;
    line-height: 116px;
  }
}
</style>
